import { emails, fetchFlow } from '@/lib/api/email-flows';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib';
import { useStanQuery } from '@/queries';

/**
 * Fetch broadcast data
 */
export function useBroadcastData(flowId: number) {
    return useStanQuery({
        queryKey: [QUERY_KEYS.FLOW_DETAILS, flowId],
        queryFn: () => fetchFlow(flowId),
        enabled: flowId > 0,
        staleTime: 1000 * 60 * 10,
        meta: {
            error: {
                sentryMessage: 'Failed to fetch broadcast data',
                title: 'Error Loading Broadcast',
                message: 'Unable to load broadcast details. Please try again.',
                feature: SENTRY_FEATURES.EMAIL_FLOWS,
            },
        },
    });
}

/**
 * Fetch broadcast template variables
 */
export function useBroadcastTemplateVariables() {
    return useStanQuery({
        queryKey: [QUERY_KEYS.EMAIL_TEMPLATE_VARIABLES, 'flow_broadcast'],
        queryFn: () => emails.fetchEmailTemplateVariables('flow_broadcast'),
        staleTime: 1000 * 60 * 30,
        meta: {
            error: {
                sentryMessage: 'Failed to fetch broadcast template variables',
                title: 'Error Loading Template',
                message: 'Unable to load email template variables. Please try again.',
                feature: SENTRY_FEATURES.EMAIL_FLOWS,
            },
        },
    });
}
